import { EmailCredentials, LoginUserResult, RegistrationPayload, SocialCredentials, User } from "../models/auth.model";
import { ModifyUser } from "../models/user.model";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  loginWithSocialProvider({ provider, accessToken }: SocialCredentials) {
    return axios.get().post<ApiResponse<LoginUserResult>>(`/account/social/${provider}`, { accessToken });
  },
  loginWithEmailPassword(payload: EmailCredentials) {
    return axios.get().post<ApiResponse<LoginUserResult>>(`/account/login`, payload);
  },
  getUser() {
    return axios.get().get<ApiResponse<User>>(`/user`);
  },
  registration(payload: RegistrationPayload) {
    return axios.get().post<ApiResponse<User>>(`/account/register`, payload);
  },
  postUser(modifyUser: ModifyUser) {
    const formData = new FormData();
    const fields = modifyUser as any;

    Object.keys(fields).forEach(key => {
      formData.append(key, fields[key]);
    });

    return axios.get().post<ApiResponse<User>>(`user`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  },
  loginWithUserId(userId: number) {
    return axios.get().post<ApiResponse<LoginUserResult>>(`/account/loginas/${userId}`);
  }
};
